(function(){
  "use strict";
  var root = document.getElementById('mfb-root');
  if(!root) return;

  var packSelect   = document.getElementById('mfb-pack-select');
  var colorRow     = document.getElementById('mfb-color-row');
  var colorCount   = document.getElementById('mfb-color-count');
  var requiredNum  = document.getElementById('mfb-color-required-num');
  var buyLabel     = document.getElementById('mfb-buy-label');
  var stickyPrice  = document.getElementById('mfb-sticky-price');
  var stickyPack   = document.getElementById('mfb-sticky-pack');
  var qtyVal       = document.getElementById('mfb-qty-val');
  var atcBtn       = document.getElementById('mfb-atc-btn');
  var buyBtn       = document.getElementById('mfb-buy-btn');
  var stickyBuyBtn = document.getElementById('mfb-sticky-buy-btn');
  var form         = document.getElementById('mfb-form');

  var state = { variantId:null, price:0, label:'', required:1, colours:[] };

  function money(paise){ return '₹' + Math.round(paise/100).toLocaleString('en-IN'); }

  function renderColourCount(){
    if(colorCount) colorCount.textContent = state.colours.length + ' of ' + state.required + ' selected';
    if(requiredNum) requiredNum.textContent = state.required;
  }

  function updateButtons(){
    var ok = !!state.variantId && state.colours.length === state.required;
    if(atcBtn) atcBtn.disabled = !ok;
    if(buyBtn) buyBtn.disabled = !ok;
    if(stickyBuyBtn) stickyBuyBtn.disabled = !ok;
    if(buyLabel) buyLabel.textContent = ok ? 'Buy Now — ' + money(state.price) : 'Select your colours';
    if(stickyPrice) stickyPrice.textContent = ok ? money(state.price) : 'Select colours';
    if(stickyPack) stickyPack.textContent = state.label || 'Out of stock';
  }

  if(packSelect){
    packSelect.addEventListener('click', function(e){
      var opt = e.target.closest('.mfb-pack-opt');
      if(!opt || opt.dataset.available !== 'true') return;
      document.querySelectorAll('.mfb-pack-opt').forEach(function(x){ x.classList.remove('sel'); });
      opt.classList.add('sel');
      state.variantId = opt.dataset.variantId;
      state.price = parseFloat(opt.dataset.price);
      state.label = opt.querySelector('.mfb-po-name').textContent;
      state.required = parseInt(opt.dataset.braCount, 10) || 1;

      // trim any over-selected colours down to the new required count
      if(state.colours.length > state.required){
        var toRemove = state.colours.slice(state.required);
        state.colours = state.colours.slice(0, state.required);
        toRemove.forEach(function(c){
          var tile = colorRow.querySelector('.mfb-color-tile[data-color="' + c + '"]');
          if(tile) tile.classList.remove('picked');
        });
      }
      renderColourCount();
      updateButtons();
    });
  }

  if(colorRow){
    colorRow.addEventListener('click', function(e){
      var tile = e.target.closest('.mfb-color-tile');
      if(!tile || tile.classList.contains('oos')) return;
      var color = tile.dataset.color;
      var idx = state.colours.indexOf(color);
      if(idx > -1){ state.colours.splice(idx,1); tile.classList.remove('picked'); }
      else{
        if(state.colours.length >= state.required) return;
        state.colours.push(color); tile.classList.add('picked');
      }
      renderColourCount();
      updateButtons();
    });
  }

  var qty = 1;
  var qtyMinus = document.getElementById('mfb-qty-minus');
  var qtyPlus = document.getElementById('mfb-qty-plus');
  if(qtyMinus) qtyMinus.addEventListener('click', function(){ qty = Math.max(1, qty-1); if(qtyVal) qtyVal.textContent = qty; });
  if(qtyPlus) qtyPlus.addEventListener('click', function(){ qty = Math.min(10, qty+1); if(qtyVal) qtyVal.textContent = qty; });

  var washToggle = document.getElementById('mfb-wash-toggle');
  var washBody = document.getElementById('mfb-wash-body');
  if(washToggle && washBody){
    washToggle.addEventListener('click', function(){
      var open = washToggle.getAttribute('aria-expanded') === 'true';
      washToggle.setAttribute('aria-expanded', String(!open));
      washBody.hidden = open;
    });
  }

  document.querySelectorAll('.mfb-acc-head').forEach(function(btn){
    var body = btn.nextElementSibling;
    btn.addEventListener('click', function(){
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      body.hidden = open;
    });
  });

  document.querySelectorAll('.mfb-faq-item').forEach(function(item){
    var btn = item.querySelector('.mfb-faq-q');
    var body = item.querySelector('.mfb-faq-a');
    if(!btn || !body) return;
    btn.addEventListener('click', function(){
      var open = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.mfb-faq-q').forEach(function(b){
        b.setAttribute('aria-expanded','false');
        var a = b.closest('.mfb-faq-item').querySelector('.mfb-faq-a');
        if(a) a.hidden = true;
      });
      if(!open){ btn.setAttribute('aria-expanded','true'); body.hidden = false; }
    });
  });

  var mainImg = root.querySelector('.mfb-gallery img');
  document.querySelectorAll('.mfb-thumbs img').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.mfb-thumbs img').forEach(function(x){x.classList.remove('sel');});
      t.classList.add('sel');
      if(mainImg) mainImg.src = t.dataset.full;
    });
  });

  function addToCart(redirectToCheckout){
    var ok = !!state.variantId && state.colours.length === state.required;
    if(!ok){
      if(colorRow) colorRow.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    var item = { id: parseInt(state.variantId,10), quantity: qty };
    var props = {};
    state.colours.forEach(function(c, i){ props['Colour ' + (i+1)] = c; });
    if(state.colours.length) item.properties = props;

    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items:[item] })
    })
    .then(function(res){ if(!res.ok) return res.json().then(function(e){ throw new Error(e.description||'Add to cart failed'); }); return res.json(); })
    .then(function(){
      if(redirectToCheckout){ 
        // window.location.href = '/checkout'; 
  
      CashfreeOcc.initCheckout(buyBtn);
      }
      else{ document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:open')); }
    })
    .catch(function(err){ alert(err.message || 'Something went wrong — please try again.'); });
  }

  if(form) form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(false); });
  if(buyBtn) buyBtn.addEventListener('click', function(){ addToCart(true); });
  if(stickyBuyBtn) stickyBuyBtn.addEventListener('click', function(){ addToCart(true); });

  var defaultOpt = packSelect ? packSelect.querySelector('.mfb-pack-opt[data-available="true"]') : null;
  if(defaultOpt) defaultOpt.click();
})();